<template>
    <div id="productListContainer">
        <Button class="btn-close" close @click="$emit('modalClosed')" />
        <PochiRadioToggleButtons class="switchProductType" v-model="productType" :values="[
            { label: '単品商品',     value: 'single' },
            { label: '商品グループ',     value: 'totalling' },
        ]" />
        <RankingProductList v-if="productType != 'totalling'" show-selected :selectedProducts="selectedProducts" v-bind:listColumn=listColumnSuu>
        </RankingProductList>
        <RankingTotallingTargetList v-if="productType == 'totalling'" show-selected :totallingTargets="totallingTargets">
        </RankingTotallingTargetList>
        <div class="settingFooter">
            <a class="btn submitBtn" @click="update">更新</a>
        </div>`
        
    </div>
    
</template>

<script>
import RankingProductList from '@/components/RankingProductList.vue';
import RankingTotallingTargetList from '@/components/RankingTotallingTargetList.vue';
import responsive from '@/helpers/responsive'

export default {
    name: 'ExcludeRanking',
    components: {
        RankingProductList,
        RankingTotallingTargetList,
    },
    props: {
        selectedProductAndRateIndex: Number,
        modalType: String,
    },
    data() {
        return {
            productType: 'single',
            originalSettings: [],
            selectedProducts: [],
            totallingTargets: [],
            isLoading: true,
            listColumnSuu: 3,
        }
    },
    mounted() {
        this.fetchProductSettings();
        this.fetchTotallingTarget();
        this.listColumnSuu = responsive.recycleScrollerListColumn();
        window.addEventListener('resize', this.resizeWindow);
    },
    methods:{
        fetchProductSettings() {
            // 商品設定を取得
            let url = '/api/productSettings';
            this.axios.get(url)
            .then((res) => {
                // ランキング除外設定を抽出
                var data = {...res.data};
                var ids = [];
                for (var setting of data.product_settings) {
                    if (setting.is_ranking_excluded === 1) {
                        ids.push(setting.product_id);
                    }
                }
                // 削除判定するため、もとの設定を保存
                this.originalSettings = [...ids];
                this.selectedProducts = [...ids];
            }).catch(() => {
            });
        },
        fetchTotallingTarget() {
            // 商品設定を取得
            let url = '/api/totallingTargets';
            this.axios.get(url)
            .then((res) => {
                // ランキング除外設定を抽出
                this.totallingTargets = [...res.data];
            }).catch(() => {
            });
        },
        update() {
            this.updateProductSettings();
            this.updateTotallingTarget();
        },
        updateProductSettings() {
            var data = [];
            for (var id of this.originalSettings) {
                const flg = this.selectedProducts.includes(id) ? 1 : 0;
                const setting = {
                    "product_id": id,
                    "is_ranking_excluded": flg
                };
                data.push(setting);
            }
            for (var pid of this.selectedProducts) {
                if ( ! this.originalSettings.includes(pid)) {
                    const setting = {
                        "product_id": pid,
                        "is_ranking_excluded": 1
                    };
                    data.push(setting);
                }
            }

            let url = '/api/productSettings';
            this.axios.put(url, {
                "product_settings" : data,
            })
            .then(() => {

            }).catch(() => {
            }).finally(() => {
                
            });
        },
        updateTotallingTarget() {
            var data = [];
            for (var tt of this.totallingTargets) {
                var elem = {};
                elem["id"] = tt.id;
                elem["is_ranking_excluded"] = tt.is_ranking_excluded;
                data.push(elem);
            }
            let url = '/api/totallingTargets/setting';
            this.axios.put(url, {
                "totalling_targets" : data,
            })
            .then((res) => {
                if (res.status === 200) {
                    this.$emit('modalClosed');
                }
            }).catch(() => {
            }).finally(() => {
            });

        },
        resizeWindow() {
            this.listColumnSuu = responsive.recycleScrollerListColumn();
        },
    },

}
</script>

<style scoped lang="sass">
#productListContainer
    padding: 15px
    height: 90%
    width: 100%
    .btn-close
        position: absolute
        top: 15px
        right: 15px
    .switchProductType
        position: absolute
        top: 27px
        right: 33px
        align-items: center;
        padding: 0;
        height: 40px;
        white-space: nowrap;
        cursor: pointer;
        color: $grayColor
        font-size: 1.5rem;
        margin-right: 148px
        float: left
    .allproductRoas
        display: inline-flex;
        align-items: center;
        padding: 7px 24px;
        // width: 24%;
        height: 40px;
        background: #f5f5f5;
        white-space: nowrap;
        cursor: pointer;
        color: $grayColor
        font-size: 1.5rem;
        margin-right: 55px
        float: right
        text-align:center
        border: 1px solid $mainColor
        &:hover
            background: $mainColor
            color: $whiteColor
            transition: 0.2s ease-out
    .settingFooter
        display: flex
        flex: 0 1 0%
        justify-content: center
        margin-top: 20px
        .submitBtn
            border: 1px solid $mainColor
            padding: 15px 5px
            width: 100px
            &:hover
                border: 1px solid $mainColor

</style>
